import script from "./index.vue?vue&type=script&lang=ts&setup=true&name=HText"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&name=HText"

const __exports__ = script;

export default __exports__